<form class="flex flex-col" (submit)="$event.preventDefault()">
  @if (viewModel?.label || label) {
    <label [for]="id" class="ml-2 text-xs font-semibold text-lightText">
      {{ viewModel?.label || label }}
    </label>
  }

  <select
    [id]="id"
    class="p-2 h-[41px] placeholder:text-sm border border-lighterText rounded-xl placeholder:md:text-left focus:outline-none bg-white"
    [value]="currentValue"
    (change)="modelChange($event)"
  >
    @for (option of currentOptions; track option.value) {
      <option [value]="option.value">
        {{ option.label }}
      </option>
    }
  </select>
</form>
